import {
  DispatcherAuthPrefix,
  DispatcherCategoryService,
  DispatcherResource
} from 'modules/types/common';
import { getDispatcherUrl } from 'modules/utils/UrlUtils';
import { Dispatch } from 'react';
import Config from 'react-native-config';
import { AnyAction } from 'redux';
import { correlationIDSelector } from 'store/booking/metadata/selectors';
import { KEY } from 'store/booking/types';
import { cernerIdSelector, consumerIdSelector } from 'store/profile/selectors';
import { GetState } from 'store/types';
import { upcomingAppointmentsRequestStateSelector } from './selectors';

export const GET_UPCOMING_APPOINTMENTS = `${KEY}.GET_UPCOMING_APPOINTMENTS`;
export const GET_UPCOMING_APPOINTMENTS_FAIL = `${KEY}.GET_UPCOMING_APPOINTMENTS_FAIL`;
export const GET_UPCOMING_APPOINTMENTS_SUCCESS = `${KEY}.GET_UPCOMING_APPOINTMENTS_SUCCESS`;

export const getUpcomingAppointments = (useRequestState = true) => (
  dispatch: Dispatch<AnyAction>,
  getState: GetState
) => {
  const isExpansion = Config.APPOINTMENTS_EXPANSION_ENABLED === 'enabled';
  let url = '/upcomingappointments';
  if (isExpansion) {
    url = getDispatcherUrl(
      DispatcherCategoryService.HEALTH_RECORDS,
      DispatcherAuthPrefix.AUTHENTICATED,
      DispatcherResource.APPOINTMENTS_UPCOMING
    );
  }
  const state = getState();
  return dispatch({
    type: GET_UPCOMING_APPOINTMENTS,
    payload: {
      useRequestState,
      requestStateSelector: upcomingAppointmentsRequestStateSelector,
      client: isExpansion ? 'dispatcher' : 'scheduling',
      request: {
        url,
        headers: {
          'x-patient-id': cernerIdSelector(state),
          'x-dfd-consumer-id': consumerIdSelector(state),
          'x-booking-correlation-id': correlationIDSelector(state)
        }
      }
    }
  });
};
